<template>
  <nx-form-scope-card title="Fondo" icon="image" class="mt-1" collapsable>
    <v-layout row wrap>
      <nx-scrollytelling-slide-editor-form-image-field
          desktop-image-name="backgroundDesktopImage"
          mobile-image-name="backgroundMobileImage"
          image-alt-name="backgroundImageAlt"
          :desktop-image-value="draft.backgroundDesktopImage"
          :mobile-image-value="draft.backgroundMobileImage"
          :image-alt-value="draft.backgroundImageAlt"
          @selection="updateOnSelection"
      />
      <slot></slot>
      <v-flex xs12 md6 :class="{ 'pr-3': $vuetify.breakpoint.mdAndUp }">
        <nx-form-color-picker
          name="backgroundColor"
          :label="'Color de overlay'"
          :value="draft.backgroundColor"
        />
      </v-flex>
      <v-flex xs12 md6 :class="{ 'pl-3': $vuetify.breakpoint.mdAndUp }">
        <nx-form-select
          name="backgroundOpacity"
          :label="'Opacidad de overlay'"
          :items="[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0]"
          :default="100"
          :value="draft.backgroundOpacity"
        />
      </v-flex>
      <nx-form-switch
        v-if="editTransition"
        name="transition"
        validation="required"
        :label="$t('message.form.fields.opacityTransition')"
        :value="draft.transition"
      />
    </v-layout>
  </nx-form-scope-card>
</template>
<script>
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxFormSelect from '@/modules/form/components/FormSelect';
import NxScrollytellingSlideEditorFormImageField
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideEditorFormImageField';
import NxFormSwitch from '@/modules/form/components/FormSwitch';

export default {
  name: 'nx-scrollytelling-slide-background-scope',
  components: {
    NxFormColorPicker,
    NxFormScopeCard,
    NxFormSelect,
    NxScrollytellingSlideEditorFormImageField,
    NxFormSwitch,
  },
  props: {
    draft: {
      type: Object,
      required: true,
    },
    editTransition: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateOnSelection() {
      this.$emit('selection');
    },
  },
};
</script>
